"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventDispatcher = _interopRequireDefault(require("../event/EventDispatcher"));

var _utils = require("../utils");

var _sources = require("../maps/interactive/sources");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var LayerAction;

(function (LayerAction) {
  LayerAction["Select"] = "select";
  LayerAction["Deselect"] = "deselect";
  LayerAction["Change"] = "change";
})(LayerAction || (LayerAction = {}));

var getRequestParams = function (value) {
  var params = {}; // if (isPlainObject(value)) {
  // 	Object.keys(value).forEach((key) => {
  // 		const v: any = value[key];
  // 		params[key] = isPlainObject(v) ? get(v, 'value') : v;
  // 	})
  // } else if (isArray(value) && value.length > 0) {
  // 	return getRequestParams(value[0]);
  // } else {
  // 	params = { filter: value };
  // }

  if (value.filters) {
    var filters = value.filters;

    if ((0, _utils.isPlainObject)(filters)) {
      params = __assign(__assign({}, params), filters);
    } else {
      params.filter = filters;
    }
  }

  if (params.filter === 'all') {
    params.filter = '';
  }

  return params;
};

var DataSourceManager =
/** @class */
function (_super) {
  __extends(DataSourceManager, _super);

  function DataSourceManager(map, panel) {
    var _this = _super.call(this) || this;

    _this.storedSources = {};
    _this.sourceState = {};
    _this.map = map;

    _this.linkPanel(panel);

    _this.setupEvents();

    return _this;
  }

  Object.defineProperty(DataSourceManager.prototype, "sources", {
    get: function () {
      return this.storedSources;
    },
    enumerable: false,
    configurable: true
  });

  DataSourceManager.prototype.linkPanel = function (panel) {
    var _this = this;

    if (this.panel === panel) return;

    if (this.panel) {
      this.panel.off('select', this.handleSelect).off('deselect', this.handleDeselect).off('change', this.handleOptionChange);
    }

    this.panel = panel;
    this.panel.on('select', this.handleSelect.bind(this)).on('deselect', this.handleDeselect.bind(this)).on('change', this.handleOptionChange.bind(this)).on('control:change', function (e) {
      var _a = e.data || {},
          id = _a.id,
          value = _a.value,
          _b = _a.control,
          control = _b === void 0 ? {} : _b;

      if (control.id === 'opacity') {
        var source_1 = _this.map.getSource(id); // if `value` has a `segments` property, then it's a segmented button and we need to get the proper
        // data source for the selected segment instead of the button's id value


        if (value && value.segments) {
          value.segments.forEach(function (segment) {
            var segmentSource = _this.map.getSource(segment.id);

            if (segmentSource) {
              source_1 = segmentSource;
            }
          });
        }

        if (source_1 && (source_1 instanceof _sources.TileSource || source_1 instanceof _sources.VectorSource)) {
          var opacity = control.value / 100;
          source_1.setOpacity(opacity);

          _this.setSourceState(id, {
            style: {
              opacity: opacity
            }
          });
        }
      }

      _this.trigger(DataSourceManager.Event.CONTROL_CHANGE, e.data);
    });
  };

  DataSourceManager.prototype.getSource = function (id) {
    return this.sources[id];
  };

  DataSourceManager.prototype.findSource = function (id, value) {
    if (value === void 0) {
      value = undefined;
    }

    var source = this.map.getSourceForId(id);

    if (!source) {
      source = this.map.getSourceForLayer(id);
    }

    if (!source && (0, _utils.isset)(value)) {
      source = this.findSource(value);
    }

    return source;
  };

  DataSourceManager.prototype.addSource = function (id, source) {
    this.sources[id] = source;
  };

  DataSourceManager.prototype.setSourceState = function (id, state) {
    this.sourceState[id] = __assign(__assign({}, this.sourceState[id]), state);
  };

  DataSourceManager.prototype.handleSourceEvent = function (event, id) {
    switch (event) {
      case 'add':
        this.panel.select(id, true);
        break;

      case 'remove':
        this.panel.deselect(id, true);
        break;

      default:
    }
  };

  DataSourceManager.prototype.handleSelect = function (e) {
    var _a = e.data || {},
        id = _a.id,
        options = _a.options;

    var _b = this.handleAction(LayerAction.Select, e.data),
        changed = _b.changed,
        added = _b.added;

    if (changed) {
      this.trigger(DataSourceManager.Event.SELECT, {
        id: id,
        options: options,
        added: added
      });
    }
  };

  DataSourceManager.prototype.handleDeselect = function (e) {
    var _a = e.data || {},
        id = _a.id,
        options = _a.options;

    var _b = this.handleAction(LayerAction.Deselect, e.data),
        changed = _b.changed,
        removed = _b.removed;

    if (changed) {
      this.trigger(DataSourceManager.Event.DESELECT, {
        id: id,
        options: options,
        removed: removed
      });
    }
  };

  DataSourceManager.prototype.handleOptionChange = function (e) {
    var _a = e.data || {},
        id = _a.id,
        value = _a.value,
        previous = _a.previous,
        options = _a.options,
        isFilter = _a.isFilter;

    if (!value) return; // if source hasn't been added to the map yet, trigger the `select` event instead since it needs to be added

    if (this.map.hasSource(id) === false && value.filters) {
      this.panel.trigger('select', e.data);
      return;
    }

    var changed = this.handleAction(LayerAction.Change, e.data);

    if (changed && isFilter) {
      this.trigger(DataSourceManager.Event.CHANGE, {
        id: id,
        current: value,
        previous: previous,
        options: options
      });
    }
  };

  DataSourceManager.prototype.handleFilterChange = function (payload) {
    if (payload === void 0) {
      payload = {};
    }

    var _a = payload || {
      reload: true
    },
        value = _a.value,
        source = _a.source,
        reload = _a.reload,
        filters = _a.filters;

    var params = getRequestParams(value);
    params.bounds = this.map.getBounds();

    if ((0, _utils.isPlainObject)(filters)) {
      payload.filters = Object.keys(filters).reduce(function (result, key) {
        result[key] = filters[key].filters;
        return result;
      }, {});
    } // pass in params object to event data payload so event handlers can
    // override request parameters as needed


    this.trigger(DataSourceManager.Event.OPTION_CHANGE, __assign(__assign({}, payload), {
      params: params
    }));

    if (source) {
      if (!(0, _utils.isset)(reload) || reload === true) {
        source.reload(params);
      } else {
        source.render();
      }
    }
  };

  ;

  DataSourceManager.prototype.handleAction = function (action, info) {
    var id = info.id,
        value = info.value,
        previous = info.previous,
        options = info.options,
        reload = info.reload; // console.log('DATASOURCE', action, info);

    if (!value) {
      return {
        changed: false,
        added: [],
        removed: []
      };
    }

    if (this.map.isReady()) {
      var added = [];
      var removed = [];

      if (value.segments) {
        if (action === LayerAction.Deselect) {
          removed = removed.concat(value.segments.filter(function (item) {
            return (0, _utils.isset)(item);
          }));
        } else {
          added = added.concat(value.segments.filter(function (item) {
            return (0, _utils.isset)(item);
          }));

          if (previous && previous.segments) {
            removed = removed.concat(previous.segments.filter(function (item) {
              return (0, _utils.isset)(item);
            }));
          }
        }
      } else if (value.filters) {
        if (action === LayerAction.Deselect) {
          removed.push({
            id: id,
            value: value,
            options: options
          });
        } else {
          added.push({
            id: id,
            value: id,
            options: value.options
          });
        }

        var source = this.findSource(id, value);
        this.handleFilterChange({
          id: id,
          value: value,
          filters: value.filters,
          options: value.options,
          source: source,
          reload: (0, _utils.isset)(reload) ? reload : true
        });

        if (action === LayerAction.Change) {
          return {
            changed: true,
            added: added,
            removed: removed
          };
        }
      } else if (action === LayerAction.Select) {
        added.push({
          id: id,
          value: value,
          options: options
        });
      } else if (action === LayerAction.Deselect) {
        removed.push({
          id: id,
          value: value,
          options: options
        });
      }

      if (action === LayerAction.Select) {
        removed = [];
      } else if (action === LayerAction.Deselect) {
        added = [];
      }

      var addedValues_1 = added.map(function (item) {
        return item.value;
      });
      var removedFiltered = removed.reduce(function (result, item) {
        if (addedValues_1.indexOf(item.value) === -1) {
          result.push(item);
        }

        return result;
      }, []); // console.log('DATASOURCE', 'added', added, addedValues, 'removed', removed, 'filtered', removedFiltered);

      if (added.length > 0 || removedFiltered.length > 0) {
        var sourcesToAdd = added.map(function (item) {
          return {
            id: item.id,
            parentId: id,
            value: (0, _utils.isPlainObject)(item.value) ? item.value.value : item.value,
            options: item.options
          };
        });
        var sourcesToRemove = removedFiltered.map(function (item) {
          return {
            id: item.id,
            parentId: id,
            value: (0, _utils.isPlainObject)(item.value) ? item.value.value : item.value,
            options: item.options
          };
        });
        this.updateSources(sourcesToAdd, sourcesToRemove);
        return {
          changed: true,
          added: added,
          removed: removedFiltered
        };
      }
    }

    return {
      changed: false,
      added: [],
      removed: []
    };
  };

  DataSourceManager.prototype.updateSources = function (sourcesToAdd, sourcesToRemove) {
    var _this = this;

    if (sourcesToAdd === void 0) {
      sourcesToAdd = [];
    }

    if (sourcesToRemove === void 0) {
      sourcesToRemove = [];
    }

    var added = [];
    var removed = [];

    var findSource = function (id) {
      var source = _this.map.getSourceForId(id);

      if (!source) {
        source = _this.map.getSourceForLayer(id);
      }

      return source;
    }; // console.log(sourcesToAdd, sourcesToRemove);


    sourcesToRemove.forEach(function (item) {
      var id = item.id,
          value = item.value,
          options = item.options;
      var source = findSource(id);

      if (!source) {
        source = findSource(value);
      }

      if (source) {
        _this.map.removeSource(source);

        removed.push(source);
      }
    });
    sourcesToAdd.forEach(function (item) {
      var id = item.id,
          parentId = item.parentId,
          value = item.value,
          options = item.options;
      var sourceOptions = (0, _utils.extend)({}, options, _this.sourceState[id], _this.sourceState[parentId]);
      var source = findSource(id);

      if (!source) {
        source = _this.getSource(id);

        if (source) {
          _this.map.addSource(source, sourceOptions);
        } else {
          _this.map.addLayer(value, __assign(__assign({}, sourceOptions), {
            id: id
          }));

          source = _this.map.getSourceForLayer(value);
        }

        if (source) {
          added.push(source);
        }
      }
    });
  };

  DataSourceManager.prototype.setupEvents = function () {};
  /**
   * Events that can be triggered by a `DataSourceManager` instance.
   *
   * @static
   * @memberof DataSourceManager
   */


  DataSourceManager.Event = {
    /** Fired when a layer is selected from the layers control panel. */
    SELECT: 'select',

    /** Fired when a layer is deselected from the layers control panel. */
    DESELECT: 'deselect',

    /** Fired when the selected option in a group changes from the layers control panel. */
    CHANGE: 'change',

    /** Fired when the selected options change within a filter group from the layers control panel. */
    OPTION_CHANGE: 'change:option',

    /** Fired when one of the settings control values associated with a layer button changes. */
    CONTROL_CHANGE: 'change:control'
  };
  return DataSourceManager;
}(_EventDispatcher.default);

var _default = DataSourceManager;
exports.default = _default;
module.exports = exports.default;